import { useController } from 'react-hook-form';

interface HiddenFieldProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
}
export function HiddenField({ name }: HiddenFieldProps) {
  const { field } = useController({
    name,
  });
  return <input type='hidden' {...field} />;
}
